<template>
    <div>
        <!-- 顶部欢迎及注册登录按钮导航 -->
        <header-top/>
        <!-- 顶部公司logo及导航栏 -->
        <logo-head></logo-head>
        <!-- 导航栏 -->
        <nav-head></nav-head>
        <!-- 商品信息主体 -->
        <div class="w-100 goodsInfoOut">
            <div class="goodsInfoContent">
                <!-- 面包屑导航 -->
                <div class="breadCrumb">
                    <span>当前位置：</span>
                    <div class="pl-1 pt-1">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">易知网</el-breadcrumb-item>
                            <el-breadcrumb-item
                            ><a :href="mbxLink">{{mbx}}</a></el-breadcrumb-item
                            >
                            <el-breadcrumb-item>商品详情</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
                <!-- 商品图片信息及恒达二维码 -->
                <div class="bg-white w-100">
                    <div class="infoTop">
                        <!-- 商品图片 -->
                        <div class="goodsImg border mr-3">
							<el-skeleton style="width:300px" animated :loading="loading">
							<template #template>
							  <el-skeleton-item variant="image" style="width: 300px; height:300px" />
							</template>
							<template #default>
								<div>
									<img :src="hotPatent.logoUrl" width="298" height="149">
								</div>
							</template>
							</el-skeleton>
                        </div>
                        <!-- 商品描述 -->
                        <div class="goodsDesc">
                            <div class="title mt-3">{{hotPatent.name}}</div>
                            <div class="d-flex pt-4">
                                <span>参考价格：<span
                                        style="color: #C32A1A;font-size: 18px;">{{hotPatent.chargeAmount}}</span></span>
                            </div>
                            <div class="descTypeInfo mt-4">
                                <div class="pl-3" style="color: #999;" v-show="type == 'patent'">
                                    <p class="pt-1">类型：{{hotPatent.patentType}}</p>
                                    <p>专利号：{{hotPatent.number}}</p>
                                    <p>申请日期：{{hotPatent.applyTime}}</p>
                                    <p>案件状态：{{hotPatent.caseStatus}}</p>
                                </div>
								<div class="pl-3" style="color: #999;" v-show="type == 'brand'">
								    <p class="pt-1">类型：{{hotPatent.type}}</p>
								    <p>地区：{{hotPatent.area}}</p>
								    <p>申请日期：{{hotPatent.registerTime}}</p>
								    <p>证书状态：{{hotPatent.cardStatus}}</p>
								</div>
								<div class="pt-3 pl-3" style="color: #999;" v-show="type == 'base'">
								    <p>服务类型：{{hotPatent.baseServeType}}</p>
								    <p>类别：{{hotPatent.type}}</p>
								</div>
                            </div>
                            <div class="pt-4">
                                <el-button type="danger" @click="buyForm(id)" class="el-icon-bank-card" plain>联系购买
                                </el-button>
                               <span class="pl-3" style="cursor: pointer;" @click="CollectionGoods" v-show="type !== 'base'">
									<svg class="icon" width="20" height="20" viewBox="0 0 1024 1024"
                                         xmlns="http://www.w3.org/2000/svg" data-v-042ca774=""
                                         v-show="!collection"><path fill="currentColor"
                                                                              d="M512 747.84l228.16 119.936a6.4 6.4 0 009.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 00-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 00-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 00-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 009.28 6.72L512 747.84zM313.6 924.48a70.4 70.4 0 01-102.144-74.24l37.888-220.928L88.96 472.96A70.4 70.4 0 01128 352.896l221.76-32.256 99.2-200.96a70.4 70.4 0 01126.208 0l99.2 200.96 221.824 32.256a70.4 70.4 0 0139.04 120.064L774.72 629.376l37.888 220.928a70.4 70.4 0 01-102.144 74.24L512 820.096l-198.4 104.32z"></path></svg>
									<svg class="icon" width="20" height="20" viewBox="0 0 1024 1024"
                                         xmlns="http://www.w3.org/2000/svg" data-v-042ca774="" color="orange"
                                         v-show="collection"><path fill="currentColor"
                                                                             d="M283.84 867.84L512 747.776l228.16 119.936a6.4 6.4 0 009.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 00-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 00-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 00-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 009.28 6.72z"></path></svg>
									<span style="position: relative;top:1px;left:2px;">{{collection ? '取消收藏' : '收藏'}}</span>
								</span>
                            </div>
                        </div>
                        <!-- 联系方式 -->
                        <div class="wxPhone">
                            <div class="imgContent">
                                <img :src="wxImg" width="180" height="180">
                            </div>
                            <div style="margin-left: 30px;text-align: center;padding-top: 10px;">想要了解更多？微信扫一扫</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 商品信息描述 -->
        <div class="infoDesc">
            <div class="descContent">
                <!-- 左侧商品描述 -->
                <div class="leftDesc">
                    <!-- 标题导航 -->
                    <div>
                        <el-menu default-active="1" class="el-menu-demo" mode="horizontal" text-color="#C32A1A"
                                 active-text-color="#C32A1A">
                            <el-menu-item index="1" style="margin-left:20px;">详情信息</el-menu-item>
                        </el-menu>
                    </div>
                    <!-- 专利详情 -->
                    <div class="goodDetailDesc">
                        <div v-html="hotPatent.content"></div>
                    </div>
                </div>
                <!-- 右侧推荐商品列表 -->
                <div class="rightImgList">
                    <!-- 推荐标题 -->
                    <div style="height: 60px;font-size: 18px;font-weight: bold;" class="p-4">
                        精选推荐
                    </div>
                    <!-- 商品列表 -->
                    <div>
                        <div v-for="(item,index) in hotList" class="d-inline-block hot_card_list ml-5 mb-3" :key="index"
                             style="cursor: pointer;">
                            <show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :price="item.chargeAmount"
                                       @click="goodsShow(item.id,'精选推荐')"></show-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 联系购买填写称呼弹窗 -->
        <el-dialog v-model="wantBuyDialog" title="联系我们" width="400px" :modal="false">
<!--            <el-form :model="wantBuyForm">
                <el-form-item label="请输入您的称呼" :label-width="formLabelWidth">
                    <el-input v-model="wantBuyForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="" prop="sex">
                    <el-radio-group v-model="wantBuyForm.sex">
                        <el-radio label="先生"></el-radio>
                        <el-radio label="女士"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form> -->
			
				<p>商版部：0631-5678759</p>
				<p>电子邮箱：hengdateam@163.com</p>
				<p>威海恒誉润达专利代理事务所（普通合伙)：0631-5679759</p>
			
            <template #footer>
		      <span class="dialog-footer">
		        <el-button @click="wantBuyDialog = false">我知道了</el-button>
		        <el-button type="primary" @click="confirmCommit" v-show="!isLogin">还未登录~去登录</el-button>
		      </span>
            </template>
        </el-dialog>
        <!-- 底部导航 -->
        <div>
            <Footer border></Footer>
        </div>
    </div>
</template>

<script>
    import HeaderTop from '@/components/headerTop/headerTop.vue'
    import LogoHead from '@/components/logoHead/logoHead.vue'
    import showCard from '@/components/showCard/showCard.vue'
    import NavHead from '@/components/navHead/navHead.vue'
    import Footer from '@/components/footer/footer.vue'
    import {ElNotification} from 'element-plus'

    export default {
        components: {
            HeaderTop,
            showCard,
            LogoHead,
            NavHead,
            Footer
        },
        data() {
            return {
                hotPatent: {},
                // 想要购买弹窗
                wantBuyDialog: false,
                // 个人信息弹窗
                wantBuyForm: {
                    name: '易知网用户',
                    sex: '先生'
                },
				loading:false,
                // 收藏状态
                collection: false,
				// 微信二维码
				wxImg:'',
                hotList: [],
                mbx: '',
                mbxLink: '',
                id: 0,
                type: '',
				isLogin:window.sessionStorage.getItem('token')
            }
        },
        mounted() {
            this.mbx = this.$route.query.mbx
            this.mbxLink = this.$route.query.mbxLink
            this.id = this.$route.query.id
            this.type = this.$route.query.type
            this.getHotPatent(this.id)
			this.getHotList()
			this.getWxImg()
        },
        methods: {
            // 获取数据
            getHotPatent(id) {
                let vm = this
				vm.loading = true
                let linkUrl = ''
                if (this.type == 'patent') {
                    linkUrl = `/api/patent/detailFindById/${id}`
                } else if (this.type == 'brand') {
                    linkUrl = `/api/brand/detailFindById/${id}`
                }else if(this.type == 'base'){
					linkUrl = `/api/base/serve/detailFindById/${id}`
				}
                this.axios.get(linkUrl).then(res => {
                    if (this.type == 'patent') {
                        vm.hotPatent = res.data.data.patent
                    } else if (this.type == 'brand') {
                        vm.hotPatent = res.data.data.brand
                    }else if (this.type == 'base') {
                        vm.hotPatent = res.data.data
                    }
					vm.collection = res.data.data.collectMark
					vm.loading = false
                }).catch(err=>{
					vm.loading = false
				})
            },
			// 获取精选推荐数据
			getHotList(){
				let vm = this
				let hotUrl = '/api/patent/findHotByUrl'
				if(this.type == 'base'){
					hotUrl = '/api/base/serve/findHot'
				}else{
					hotUrl = `/api/${this.type}/findHotByUrl`
				}
				this.axios.get(hotUrl,{params:{url:this.type, count:3}
				}).then(res => {
					this.hotList = res.data.data
				})
			},
			// 获取二维码
			getWxImg(){
				this.axios.get('/api/material/findMaterial').then(res => {
					this.wxImg = res.data.data.qrCodeUrl
				})
			},
            // 点击联系购买
            buyForm(id) {
                let vm = this
                let isLogin = window.sessionStorage.getItem('token')
				vm.wantBuyDialog = true
				vm.commitBuyInfo()
            },
            // 去登陆
            confirmCommit() {
                let vm = this
                vm.$router.push('/login')
            },
            // 提交联系购买需求事件
            commitBuyInfo() {
                let vm = this
                this.axios.post('/api/link/buy/good',{
                    goodId: vm.id,
                    mbx: vm.mbx,
                    mbxLink: vm.type,
                    goodName: vm.hotPatent.name
                }).then(res => {
                    if (res.data.success) {
                        // 成功提示
                        ElNotification({
                            title: '意向提交',
                            message: res.data.msg,
                            type: 'success', //警告:warning,信息:info,失败:danger,成功success
                        })
                    } else {
                        // 成功提示
                        ElNotification({
                            title: '意向提交',
                            message: res.data.msg,
                            type: 'danger', //警告:warning,信息:info,失败:danger,成功success
                        })
                    }
                }).catch(err => {
                })
            },
            // 进入商品详情页
            goodsShow(id, mbx, mbxLink) {
				let vm = this
                let routeData = this.$router.resolve({
                    path: '/goodsInfo',
                    query: {
						id:id,
						mbx: vm.mbx,
						mbxLink: vm.type,
						type:vm.type
                    }
                })
                window.open(routeData.href, '_blank');
            },
            CollectionGoods() {
                let vm = this
                let isLogin = window.sessionStorage.getItem('token')
                if (!isLogin) {
                    this.$router.push('/login')
                } else {
                    let linkUrl = '/api/collect/saveOrUpdate'
                    // 发送收藏或取消收藏的请求
                    this.axios.post(linkUrl, {
                        goodId: vm.id,
                        mbx: vm.mbx,
                        mbxLink: vm.type,
                        goodName: vm.hotPatent.name
                    }).then(res => {
						vm.collection = !vm.collection
                        // 成功提示
                        ElNotification({
                            title: res.data.data,
                            message: res.data.msg,
                            type: 'success', //警告:warning,信息:info,失败:danger,成功success
                        })
                    }).catch(err => {
						
                    })
                }
            },
        },
    }
</script>

<style scoped>
    /* 外层容器 */
    .goodsInfoOut {
        width: 100%;
        overflow: hidden;
        background-color: #f8f8f8;
    }

    .goodsInfoContent {
        width: 1200px;
        min-height: 500px;
        margin: 0 auto;
        margin-top: 5px;
    }

    .breadCrumb {
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    /* 图片信息二维码 */
    .infoTop {
        width: 1200px;
        height: 450px;
        background-color: #fff;
        display: flex;
        padding: 15px;
    }

    .infoTop .goodsImg {
        width: 300px;
        height: 320px;
		display: flex;
		justify-content: center;
		align-items: center;
    }

    .infoTop .goodsDesc {
        width: 570px;
        min-height: 450px;
    }

    .infoTop .goodsDesc .title {
        font-size: 16px;
        color: #333;
        font-weight: bold;
    }

    /* 商品信息类型 */
    .descTypeInfo {
        width: 550px;
        height: 150px;
        background-color: #f8f8f8;
    }

    /* 右侧二维码窗口 */
    .wxPhone {
        height: 500px;
    }

    .wxPhone .imgContent {
        width: 200px;
        height: 200px;
        margin-left: 30px;
        border: 2px solid #f0f0f0;
        text-align: center;
        margin-top: 30px;
    }

    /*  下方商品详情 */
    .infoDesc {
        width: 100%;
        background-color: #f8f8f8;
        overflow: hidden;
    }

    .infoDesc .descContent {
        width: 1200px;
        min-height: 850px;
        margin: 0 auto;
        display: flex;
        margin-bottom: 20px;
    }

    .infoDesc .descContent .leftDesc {
        width: 870px;
        min-height: 850px;
        background-color: #fff;
    }

    .infoDesc .descContent .rightImgList {
        width: 300px;
        min-height: 850px;
        background-color: #fff;
        margin-left: 30px;
    }

    .infoDesc .descContent .goodDetailDesc {
        width: 800px;
        min-height:750px;
        margin: 0 auto;
        margin-top: 20px;
		position: relative;
		background-image: url(../../assets/img/goodsInfo/goodsInfoBg.png);
    }
</style>
